import React, { useEffect, useState } from 'react'

import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const Footer = (props) => {
    const [resources, setResources] = useState({});

    let navigate = useNavigate();

    const { language } = useParams();

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            break;
        case ("en" || "EN"):
            break;
        default:
            break;
    }

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    let languageNavPath = props.pagePath;

    return (
        <div className="footer">
            <div className="row mt-5">
                <div className="col-md-12 text-center">
                    <p><small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none', fontSize: '12px' }} href={`https://organizer.ticketino.com/${language}`} target="_blank">TICKETINO</a></small></p>
                </div>
            </div>
        </div>
    )
}

export default Footer